import { useContext } from "react";
import { InboxPanelContext } from "@/contexts/InboxPanelContext";

export const useInboxPanel = () => {
  const context = useContext(InboxPanelContext);

  if (!context) {
    throw new Error("useInboxPanel must be used within an InboxPanelProvider");
  }

  return context;
};
